import React, { Component } from 'react';
import { Content, FlexboxGrid } from 'rsuite';
import StoragePageLayout from '../../../components/storage/PageLayout';
import PageHeader from '../../../components/PageHeader';
import StorageUnitCard from '../../../components/storage/UnitCard';

class StorageDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <StoragePageLayout>
        <PageHeader title="Dashboard" />
        <Content>
          <FlexboxGrid justify="space-around">
            <StorageUnitCard />
            <StorageUnitCard />
            <StorageUnitCard />
            <StorageUnitCard />
          </FlexboxGrid>
        </Content>
      </StoragePageLayout>
    );
  }
}

export default StorageDashboard;
